import * as fromCart from './cart.actions';
import * as fromState from './state.actions';
import { createReducer } from '@reduxjs/toolkit';
import { ICartProduct } from '../models/cart.model';

export interface ICartState {
  paymentTypeId: string | null;
  products: ICartProduct[];
  organizationCode: string;
  comment: string;
  promoCode: string | null;
}

export const initialState: ICartState = {
  paymentTypeId: null,
  products: [],
  organizationCode: '',
  comment: '',
  promoCode: null,
};

export const cartReducer = createReducer(initialState, (builder) => {
  builder.addCase(fromCart.cartFetchAction, (state, action) => {
    const cartData = localStorage.getItem(action.payload.toUpperCase() + '_Cart');
    let cartProducts: ICartProduct[] = [];
    if (cartData) {
      cartProducts = JSON.parse(cartData);
    }
    return {
      ...state,
      products: cartProducts,
      organizationCode: action.payload
    };
  });

  builder.addCase(fromCart.cartAddProductAction, (state, action) => {
    return {
      ...state,
      products: [
        ...state.products,
        {...action.payload}
      ]
    };
  });

  builder.addCase(fromCart.cartUpdateProductAction, (state, action) => {
    const foundIndex = state.products.findIndex(value => value.positionId === action.payload.product.positionId);
    const updatedProducts = [...state.products];
    if (foundIndex !== -1) {
      const newQuantity = action.payload.product.quantity + action.payload.quantity;
      if (newQuantity > 0) {
        updatedProducts[foundIndex] = {
          ...action.payload.product,
          quantity: newQuantity
        };
      } else {
        updatedProducts.splice(foundIndex, 1);
      }
    }

    return {
      ...state,
      products: updatedProducts
    };
  });

  builder.addCase(fromCart.cartDeleteProductAction, (state, action) => {
    const products = state.products.filter(value => value.positionId !== action.payload.positionId);

    return {
      ...state,
      products: [...products]
    };
  });

  builder.addCase(fromCart.cartClearAction, (state) => {
    return {
      ...state,
      products: [],
      promoCode: null
    };
  });

  builder.addCase(fromCart.cartPaymentTypeIdAction, (state, action) => {
    return {
      ...state,
      paymentTypeId: action.payload,
    };
  });

  builder.addCase(fromCart.cartCommentAction, (state, action) => {
    return {
      ...state,
      comment: action.payload,
    };
  });

  builder.addCase(fromCart.cartPromoCodeAction, (state, action) => {
    return {
      ...state,
      promoCode: action.payload,
    };
  });

  builder.addCase(fromCart.cartSetUploadDiscountStatusAction, (state, action) => {
    return {
      ...state,
      uploadDiscountStatus: action.payload,
    };
  });

  // Если сменяется текущий адрес доставки, то корзину нужно почистить
  builder.addCase(fromState.setCurrentAddressAction, (state, action) => {
    return {
      ...state,
      products: [
        ...state.products.filter(
          value => value.deliveryTerminalId === action.payload.deliveryAddress?.deliveryTerminal?.id
        )
      ]
    };
  });
  builder.addCase(fromState.updatingCurrentAddressAction, (state, action) => {
    return {
      ...state,
      products: [
        ...state.products.filter(
          value => value.deliveryTerminalId === action.payload.deliveryAddress?.deliveryTerminal?.id
        )
      ]
    };
  });

  builder.addMatcher((action => action.type !== fromCart.cartFetchAction.type), (state: ICartState) => {
    if (state.organizationCode.length) {
      localStorage.setItem(state.organizationCode.toUpperCase() + '_Cart', JSON.stringify(state.products));
    }
  });
});
